import React from 'react';
import '../css/Header.css';

import zbrush from '../images/technologies/zbrush.png';
import maya from '../images/technologies/maya.png';
import substance from '../images/technologies/substance.png';
import marmoset from '../images/technologies/marmoset.png';
import unreal from '../images/technologies/unreal.png';
import blender from '../images/technologies/logo-blender.png';

import avatarTeacher from '../images/logo_dot.png';
import Tags from './buttons/Tags';
import dayjs from 'dayjs';
import Countdown from './Countdown';

import { useDispatch, useSelector } from 'react-redux';

import { openCounseling } from '../features/counseling';
import { openVideo } from '../features/video';

import BulletPointBlink from './buttons/BulletPointBlink';
import BulletPoint from './buttons/BulletPoint';

import Image from 'react-image-webp';

import image from '../images/3d-isolated.png';
import imageWebp from '../images/3d-isolated.png';
import imageMobile from '../images/3d-isolated-mobile.jpeg';
import imageMobileWebp from '../images/3d-isolated-mobile.jpeg';

import underline from '../images/underline.png';

const countdown = 'Tue, 24 Jun 2025 16:00:00 GMT-5';

const benefits = [
	'6 Meses Feedback en vivo.',
	'Material de ayuda.',
	'Grabaremos las clases.',
	'Acceso Discord.',
	'Certificado.',
	'Acceso 1 año.',
];

const Header = () => {
	const nowDay = dayjs();
	const openingDay = dayjs(countdown);

	const dispatch = useDispatch();

	const handleLink = (e) => {
		e.preventDefault();
		const target = e.target.getAttribute('href');
		const location = document.querySelector(target).offsetTop;
		window.scrollTo({
			left: 0,
			top: location - 80,
		});
	};

	const banner = useSelector((state) => state.banner.value.banner);
	const width = window.innerWidth <= 460 ? 40 : 20;

	const paddingTop = banner ? { paddingTop: width + 80 } : { paddingTop: 80 };

	return (
		<section className='Header' id='home' style={paddingTop}>
			<div className='header-container container '>
				<div className='header-content padding'>
					<Image src={image} webp={imageWebp} alt='Máster en Blender' className='header-image' />
					<Image
						src={imageMobile}
						webp={imageMobileWebp}
						alt='Máster en Blender'
						className='header-image-mobile'
					/>
					<div className='header-item'>
						<BulletPoint color={'#77bf41'} />
						<p>Feedback en vivo</p>
					</div>
					<h1 className='header-title'>
						MÁSTER EN
						<br />
						<span>
							BLENDER
							<img src={underline} alt='underline' className='underline' />
						</span>
					</h1>
					<div className='header-buttons'>
						<button
							className='header-button see-trailer'
							onClick={() => {
								dispatch(
									openVideo({
										modal: true,
										url: 'https://www.youtube.com/watch?v=9WJktU0EKxc',
										type: 'common',
									})
								);
							}}
						>
							VER TRAILER
						</button>

						<a
							href='https://drive.google.com/file/d/11S4HVWN2oJP_qymckLYLZxP7__Shl2se/view?usp=sharing'
							target='blank_'
							className='header-button see-payment'
							// onClick={handleLink}
						>
							VER TEMARIO
						</a>
					</div>
					<div className='master-benefits'>
						{benefits.map((benefit, index) => (
							<div key={index} className='header-item' style={{ fontWeight: 'normal' }}>
								<BulletPoint color={'#6000de'} />
								<p>{benefit}</p>
							</div>
						))}
					</div>
				</div>
				{/* <div className='header-information'>
					<div className='header-information-content'>
						<img src={avatarTeacher} alt='Avatar Teacher' />
						<p className='teacher'>
							<span>Profesor: </span>Ricardo Díaz
						</p>
						<h2>
							Agenda tu
							<br />
							asesoría gratis
						</h2>
						<Tags name={'SOLICITA ASESORÍA'} />
						{openingDay.isAfter(nowDay) ? (
							<Countdown countdownTimestampMs={countdown} />
						) : (
							<h3 className='start-master'>
								<BulletPointBlink color={'#77bf41'} />
								<span>Ya inició</span>
							</h3>
						)}
						<a href='#entrenamientos' className='payment' onClick={handleLink}>
							3 PAGOS DE <span>&nbsp;$176&nbsp;</span>USD
						</a>
						<a href='#metodos-de-pago' className='to-payment-methods' onClick={handleLink}>
							MÉTODOS DE PAGO
						</a>
						<button
							className='payment-information'
							onClick={() => {
								dispatch(openCounseling());
							}}
						>
							* Pregunta por nuestros planes
							<br /> de financiación.
						</button>
					</div>
					<div className='header-information-technologies'>
						<img src={blender} alt='technology' style={{ maxWidth: '31px' }} />
						<img src={substance} alt='technology' />
						<img src={unreal} alt='technology' />
					</div>
				</div> */}

				<div className='header-information'>
					<div className='header-information-content'>
						<img src={avatarTeacher} alt='Avatar Teacher' />
						{/* <p className='teacher'>
							<span>Profesor: </span>Ricardo Díaz
						</p> */}
						<h2>
							¿Tienes preguntas?
							<br />
							Escríbenos ahora
						</h2>
						<Tags name={'SOLICITA ASESORÍA'} />
						{openingDay.isAfter(nowDay) ? (
							<Countdown countdownTimestampMs={countdown} />
						) : (
							<h3 className='start-master'>
								<BulletPointBlink color={'#77bf41'} />
								<span>Ya inició</span>
							</h3>
						)}
						<a href='#entrenamientos' className='payment' onClick={handleLink}>
							Inscríbete Ahora
							{/* <span>&nbsp;$176&nbsp;</span>USD */}
						</a>
						<a href='#metodos-de-pago' className='to-payment-methods' onClick={handleLink}>
							MÉTODOS DE PAGO
						</a>
						<button
							className='payment-information'
							onClick={() => {
								dispatch(openCounseling());
							}}
						>
							* Pregunta por nuestros planes
							<br /> de financiación.
						</button>
					</div>
					<div className='header-information-technologies'>
						<img src={blender} alt='technology' style={{ maxWidth: '31px' }} />
						<img src={substance} alt='technology' />
						<img src={unreal} alt='technology' />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Header;
